// TODO: Voir dans quelle mesure il est possible de remplacer ces constantes
// par des valeurs calculées à partir de la définition des autres composants

// Position à laquelle le menu de gauche est affiché
// → Header + Families + Margin
export const STICKY_DESKTOP = 48 + 128 + 16;

// Position à laquelle le menu horizontal est affiché
// → Header
export const STICKY_MOBILE = 48;

// Compensation pour le scroll vers les sous-catégories
// → Header + Families + Margin
export const SCROLL_DESKTOP = 48 + 128 + 16;

// Compensation pour le scroll vers les sous-catégories
// → Header + Categories + Margin
export const SCROLL_MOBILE = 48 + 80 + 8;

// Surcharge pour le scroll si sur une catégorie recette
// → ScrollDeltaMobile - SubCatMenuHeight
export const SCROLL_MOBILE_RECIPE = SCROLL_MOBILE - 40;
